export default "__VITE_ASSET__B1sd1m3D__"